import { BadgeColor, BadgeSize, ExBadge } from '@boomi/exosphere';
import type { Connection } from './connections';
import type { Connector } from '../connectors/connectors';
import styles from './ConnectionRow.module.css';

interface ConnectionRowProps {
    connection: Connection;
    connector?: Connector | undefined;
    onSelect: (id: string) => void;
}

const ConnectionRow = ({ connection, connector, onSelect }: ConnectionRowProps) => {
    const { appId, name, identityProviderName, enabled, updatedAt } = connection;
    const updatedDate = new Date(updatedAt).toLocaleDateString(undefined, { dateStyle: 'short' });

    return (
        <button
            type="button"
            className={styles.row}
            onClick={() => onSelect(appId)}
            aria-label={name}
        >
            <span className={styles.connectionName}>{name}</span>

            {identityProviderName ? (
                <ExBadge color={BadgeColor.GRAY} size={BadgeSize.EXTRASMALL}>
                    {identityProviderName}
                </ExBadge>
            ) : (
                <span />
            )}

            <div className={styles.connectionCell}>
                {connector?.icon && <img src={connector.icon} alt="" width={18} height={18} />}
                {connector?.name && <span className={styles.connectionName}>{connector.name}</span>}
            </div>

            <span className={styles.secondaryText}>{updatedDate}</span>

            <ExBadge
                color={enabled ? BadgeColor.GREEN : BadgeColor.GRAY}
                size={BadgeSize.EXTRASMALL}
            >
                {enabled ? 'Enabled' : 'Disabled'}
            </ExBadge>
        </button>
    );
};

export default ConnectionRow;
